import { render, staticRenderFns } from "./l_and_d_approvers.vue?vue&type=template&id=71916a40"
import script from "./l_and_d_approvers.vue?vue&type=script&lang=js"
export * from "./l_and_d_approvers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports